import { Prop } from "../../models/Prop";
import usePropHelper from "../../hooks/PropHelper";
import { useEffect, useMemo } from "react";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import classNames from "classnames";
export default function PropPresetPopoverCard(props: {
  prop: Prop;
  onClick: () => void;
  checked?: boolean;
}) {
  const { prop, onClick, checked } = { ...props };
  const { getPropDTO } = usePropHelper();
  const dto = useMemo(() => getPropDTO(prop.propId), [prop.propId]);

  return (
    <div
      className={classNames(
        "flex cursor-pointer h-[46px] gap-[10px] py-[6px] px-[12px] rounded-[5px] hover:bg-interaction-text-hoverBackground",
        {
          "bg-interaction-text-selectedBackground": checked,
        }
      )}
      onClick={onClick}
    >
      <div
        className={
          "flex justify-center items-center my-auto rounded-full border-solid w-[36px] h-[36px] p-[4px] border-[2px] border-creator-primary text-[20px] text-creator-text-sub"
        }
      >
        {/* <img className={"object-contain w-full h-full"} src={dto.propContent.downloadUri} alt={prop.id}/> */}
        <ViewInArIcon color="inherit" fontSize="inherit" />
      </div>
      <span
        className={
          "my-auto font-medium truncate text-[14px] text-creator-text-sub"
        }
      >
        {prop.name}
      </span>
    </div>
  );
}
